import * as React from 'react';
import styled, { css } from 'styled-components';
import type { DefaultTheme } from 'styled-components';

import type { Event } from 'components/events/events/types';
import { Icon, IfPermitted } from 'components/common';
import useLicenseCheck from 'license/useLicenseCheck';

import AddEvidence from './CoreAddEvidence';
import AddEvidenceModal from './shared/AddEvidenceModal';

const EvidenceActionButton = styled.a(({ $disabled, theme }: { $disabled?: boolean, theme: DefaultTheme }) => css`
  display: flex;
  align-items: center;
  color: ${$disabled ? theme.colors.gray[90] : 'inherit'};
  text-decoration: none;
  gap: 6px;
  cursor: ${$disabled ? 'not-allowed' : 'pointer'};

  &:hover {
    color: ${$disabled ? theme.colors.gray[90] : 'default'};
  }

  &:visited {
    color: inherit;
  }
`);

const addToInvestigation = ({ investigationSelected }) => (
  <dd>
    <EvidenceActionButton $disabled={!investigationSelected}>
      Add to investigation <Icon name="puzzle-piece" size="sm" />
    </EvidenceActionButton>
  </dd>
);

const InvestigationsEventAction = ({ event }: { event: Event }) => {
  const addEvidenceModalRef = React.useRef(null);
  const { security } = useLicenseCheck();

  return security?.isValid && (
    <IfPermitted permissions="investigations:edit">
      <AddEvidence id={event.id} type="events" child={addToInvestigation} />
      <dd>
        <EvidenceActionButton onClick={() => addEvidenceModalRef.current.toggle()}>
          Select an investigation <Icon name="puzzle-piece" size="sm" />
        </EvidenceActionButton>
      </dd>
      <AddEvidenceModal id={event.id} type="events" ref={addEvidenceModalRef} />
    </IfPermitted>
  );
};

export default InvestigationsEventAction;
